import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedEye = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="show" size="100%" color={stroke ?? color} />
);

export { LineRoundedEye };
